<template>
  <input
    type="text"
    :class="hasError?'xn-error':''"
    @input="onKeyup"
  >
</template>

<script>
  export default {
    name: "CustomInput",
    data: () => ({
      hasError: false
    }),
    methods: {
      onKeyup(e) {
        let value = e.target.value;
        this.$emit('input', value);

        if (value === '') {
          this.hasError = false;
        } else {
          if (value.toString() === '0') {
            this.hasError = false
          } else {
            const pattern = /^-?(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
            this.hasError = !pattern.test(value);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
